'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to focus input field when flag changes to true
 */
    .directive('focusMe', function ($timeout, $parse) {
        function focus(element) {
            if (element.attr("tabindex"))
                element[0].focus();
            else {
                // delegate to first child having tab stop
                element = element.find("[tabindex]");
                if (element[0])
                    element[0].focus();
            }
        }

        return {
            link: function (scope, element, attrs) {
                var model = $parse(attrs.focusMe);
                scope.$watch(model, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            focus(element);
                        });
                    }
                });
                element.bind('blur', function () {
                    scope.$apply(model.assign(scope, false));
                });
            }
        };
    });